import enquire from 'enquire.js/dist/enquire.min';
/**
 * main nav
 */
// run js depends on the screen size
enquire.register('screen and (max-width: 992px)', {
    match: function () {
        // show mobile menu after clicking on the hamburger button
        $('.nav__container').css('display', 'none');
        $('.nav__toggler-btn').click(function () {
            // animate appearance of the menu
            if (!$('body').hasClass('js-nav--expanded')) {
                $('.nav__toggler-btn').addClass('is-active');
                $('.nav__container').slideDown();
                $('body').addClass('js-nav--expanded');
                $('.site-header__branding').addClass('js-hide');
            } else {
                $('.nav__toggler-btn').removeClass('is-active');
                $('.nav__container').slideUp(function () {
                    $('body').removeClass('js-nav--expanded');
                    $('.site-header__branding').removeClass('js-hide');
                });
            }
        });
        if ($('section.s-products-with-filter').length !== 0) {
            $('.js-filter-expand').click(function () {
                $('#filters-view, .subtitle-and-arrow').toggleClass('js-expanded');
            });
        }
        const submenuDropdown = document.querySelectorAll('.nav__menu-item--has-children, .nav__menu-item--has-mega-menu');

        if (submenuDropdown) {
            for (let i = 0; i < submenuDropdown.length; i++) {
                submenuDropdown[i].addEventListener('click', function () {
                    submenuDropdown[i].classList.toggle('open');
                    // $('.nav__sub-menu').slideToggle(); //nicer effect but interfering with desktop
                });
            }
        }
    },
    unmatch: function () {
        $('.nav__container').css('display', 'flex');
        $('body').removeClass('js-nav--expanded');
        $('.nav__container').removeClass('js-show');
        $('.nav__toggler-btn').removeClass('is-active');
        $('.site-header__branding').removeClass('js-hide');
        $('.nav__toggler-btn').off('click'); // Unbinding the click event on the toggler button.
        if ($('section.s-products-with-filter').length !== 0) {
            $('#filters-view, .subtitle-and-arrow').addClass('js-expanded');
        }
    },
});

// Menu: Add class to body when user scroll down the page
// Todo: replace with intersection observer + polyfill in the future
function fixedMenu() {
    // console.log('inside fixedMenu');
    if ($(window).scrollTop() > 0) {
        $('body').addClass('js-site-header--fixed');
    } else {
        $('body').removeClass('js-site-header--fixed');
    }
}
fixedMenu();
$(window).on('load resize scroll', function () {
    fixedMenu();
});

// Hide announcement-bar on scroll, mobile only
$(document).ready(function() {
    var lastScrollTop = 0;
    var hasHidden = false; // Flag to track

    function adjustHeaderAndSubmenuOnScroll() {
        var st = $(window).scrollTop();

        // Only apply logic for mobile views
        if ($(window).width() <= 768) {
            // Check if scrolling down
            if (st > lastScrollTop) {
                // Check if scrolled more than 10px and the bar has not been hidden yet
                if (st > 10 && !hasHidden) {
                    $('#c-announcement-bar').stop().slideUp();
                    hasHidden = true; // Set the flag to true after hiding the bar
                }
            } else {
                // If scrolling up and the bar was previously hidden, show it again
                if (hasHidden && (st < lastScrollTop - 0)) { // Require scrolling up a bit before showing again
                    $('#c-announcement-bar').stop().slideDown();
                    hasHidden = false; // Reset the flag once the bar is shown
                }
            }

            lastScrollTop = st; // Update lastScrollTop for the next scroll event
        } else {
            // For non-mobile, ensure the announcement bar is always shown
            $('#c-announcement-bar').stop().slideDown();
            hasHidden = false; // Reset the flag
        }
    }

    $(window).scroll(adjustHeaderAndSubmenuOnScroll);
    $(window).resize(adjustHeaderAndSubmenuOnScroll);
});

// Menu: search bar
$('.c-search-bar__toggle-link, .c-search-bar__close-link').click(function (e) {
    e.preventDefault();
    $('.c-search-bar').slideToggle();
    $('body').toggleClass('js-show-search-bar');
    $('.c-search-bar').css({
        display: 'flex',
    });
    $('.c-search-bar__form-input').focus();
});

// search bar - hide when click outside of nav and search-bar
$(document).mouseup(function (e) {
    var container = $('.c-search-bar, .nav');
    // hide the search bar if an area outside the container variable is clicked
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('body').removeClass('js-show-search-bar');
        $('.c-search-bar').slideUp();
    }
});

// search bar - hide when you scroll
window.onscroll = function () {
    hideSearchbar();
};

function hideSearchbar() {
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        $('body').removeClass('js-show-search-bar');
    }
}



/* If mobile menu item with submenu is clicked, open submenu. */
// const submenuDropdown = document.querySelectorAll('.nav__menu-item--has-children, .nav__menu-item--has-mega-menu');

// if (submenuDropdown) {
//     for (let i = 0; i < submenuDropdown.length; i++) {
//         submenuDropdown[i].addEventListener('click', function () {
//             submenuDropdown[i].classList.toggle('open');
//             // $('.nav__sub-menu').slideToggle(); //nicer effect but interfering with desktop
//         });
//     }
// }

/* If mobile menu language selector is clicked, open language dropdown menu. */
const languageSwitcherCurrentLanguage = document.querySelector('.c-language-switcher__current-language');
const languageSwitcherContainer = document.querySelector('.c-language-switcher');

if (languageSwitcherCurrentLanguage) {
    languageSwitcherCurrentLanguage.addEventListener('click', function () {
        languageSwitcherContainer.classList.toggle('open');
    });
}

/* If mobile menu menu-account selector is clicked, open menu account dropdown menu. */
const menuAccountCurrentUser = document.querySelector('.c-menu-account__current-user');
const menuAccountContainer = document.querySelector('.c-menu-account');

if (menuAccountCurrentUser) {
    menuAccountCurrentUser.addEventListener('click', function () {
        menuAccountContainer.classList.toggle('open');
    });
}




// WEBPACK FOOTER //
// ./scripts/routes/other/nav.js